import React, { useEffect, useRef, useState } from "react";
import { GLASS } from "../kota/ui";
import { uiProfesi } from "./profesi";
import { Hud, Petunjuk, Pop, POP_CSS, useCountdown } from "./Hud";

const TOTAL = 15;      // target per shift
const DURASI = 30;     // detik

// Mini game kerangka (dipakai profesi yang belum punya permainan sendiri): target muncul satu per satu di area kerja,
// ketuk sebelum hilang. Skor = ketukan tepat / total × 100. Posisi deterministik dari seed shift.
export function Permainan({ shift, onSelesai }) {
  const { Icon, warna } = uiProfesi(shift.profesi);
  const [target, setTarget] = useState(null);     // {i, x, y}
  const [hits, setHits] = useState(0);
  const [pop, setPop] = useState(null);
  const ref = useRef({ i: 0, hits: 0, selesai: false, timer: null });
  const hidup = Math.max(850, 1500 - (shift.level - 1) * 60);
  const rnd = i => { const x = Math.sin(shift.seed + i * 97.3) * 10000; return x - Math.floor(x); };

  function akhiri() {
    const r = ref.current;
    if (r.selesai) return;
    r.selesai = true; clearTimeout(r.timer);
    onSelesai(Math.round((r.hits / TOTAL) * 100));
  }
  function spawn() {
    const r = ref.current;
    if (r.selesai) return;
    if (r.i >= TOTAL) return akhiri();
    const i = r.i++;
    setTarget({ i, x: 12 + rnd(i) * 76, y: 10 + rnd(i + 50) * 70 });
    r.timer = setTimeout(() => { setTarget(null); r.timer = setTimeout(spawn, 300); }, hidup);
  }
  const sisa = useCountdown(DURASI, akhiri);
  useEffect(() => { const r = ref.current; r.timer = setTimeout(spawn, 600); return () => clearTimeout(r.timer); }, []); // eslint-disable-line

  function ketuk() {
    const r = ref.current;
    if (!target || r.selesai) return;
    clearTimeout(r.timer);
    r.hits += 1; setHits(r.hits);
    setPop({ x: target.x, y: target.y, k: target.i });
    setTarget(null);
    r.timer = setTimeout(spawn, 280);
  }

  const aksi = shift.aksi[Math.floor(((target?.i ?? ref.current.i) / TOTAL) * shift.aksi.length)] || shift.aksi[0];
  return (
    <>
      <style>{`@keyframes jw-target{0%{transform:translate(-50%,-50%) scale(.4);opacity:0}100%{transform:translate(-50%,-50%) scale(1);opacity:1}}
        @keyframes jw-ring{0%{transform:scale(1);opacity:.9}100%{transform:scale(1.9);opacity:0}}${POP_CSS}`}</style>
      <Hud sisa={sisa} durasi={DURASI} poin={hits} extra={[[Icon, warna, `${hits}/${TOTAL}`]]} />
      <div data-testid="kerja-arena" style={{ position: "absolute", left: 0, right: 0, top: "22%", bottom: "20%" }}>
        {target && (
          <button data-testid="kerja-target" aria-label={aksi} onPointerDown={ketuk}
            style={{ position: "absolute", left: `${target.x}%`, top: `${target.y}%`, width: 66, height: 66, borderRadius: 99, border: "1px solid var(--g-border)", background: "var(--g-bg-strong)", backdropFilter: GLASS.blur, WebkitBackdropFilter: GLASS.blur, boxShadow: GLASS.shadow, display: "grid", placeItems: "center", cursor: "pointer", padding: 0, transform: "translate(-50%,-50%)", animation: "jw-target .18s ease-out", WebkitTapHighlightColor: "transparent", touchAction: "manipulation" }}>
            <span style={{ position: "absolute", inset: -2, borderRadius: 99, border: `2.5px solid ${warna}`, animation: `jw-ring ${hidup}ms ease-out forwards` }} />
            <Icon size={26} color={warna} />
          </button>
        )}
        {pop && <Pop key={pop.k} x={`${pop.x}%`} y={`${pop.y}%`}>+1</Pop>}
      </div>
      <Petunjuk>Ketuk · {aksi}</Petunjuk>
    </>
  );
}
